import type { User } from "../types";
import { storage, KEYS } from "../services/storage";
import { defaultUser } from "./defaultUser";

/** Persisted client-only state (selected event, profile cache). */
export const localClientState = {
  getSelectedEventId(): string | null {
    return storage.get<string | null>(KEYS.SELECTED_EVENT, null);
  },

  setSelectedEventId(eventId: string): void {
    storage.set(KEYS.SELECTED_EVENT, eventId);
  },

  getUserProfile(): User {
    return storage.get<User>(KEYS.USER_PROFILE, defaultUser);
  },

  updateUserProfile(partial: Partial<User>): User {
    const next = { ...this.getUserProfile(), ...partial };
    storage.set(KEYS.USER_PROFILE, next);
    return next;
  },
};
